import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { COMMS_UNREAD_KEY, getCommsUnread, type CommsUnread } from '@/api/comms/unread.api';

/**
 * The global unread poll (Stream E, ADR-027 §4). Mounted at the AppShell
 * level (via the header chrome) and shared by both headers — TanStack
 * dedupes the 30s poll by its `['comms','unread']` key, so calling this in
 * several places issues a single request per interval. Chat send/read and
 * announcement read/ack mutations invalidate the same key for an
 * immediate badge refresh.
 */
export function useCommsUnread(): UseQueryResult<CommsUnread> {
  return useQuery({
    queryKey: COMMS_UNREAD_KEY,
    queryFn: getCommsUnread,
    refetchInterval: 30_000,
  });
}
